import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface DeltaBadgeProps {
    value: string;
    positive: boolean;
    title?: string;
    className?: string;
}

/**
 * Chip de variação (▲/▼ x%) com tooltip do tema (popover escuro, mono).
 * Usa radix (portal) → não é cortado por ancestrais com overflow-hidden.
 */
export function DeltaBadge({ value, positive, title, className }: DeltaBadgeProps) {
    const chip = (
        <span
            className={`delta-badge inline-flex items-center gap-1 rounded border border-border px-1.5 py-0.5 tabular-nums ${
                title ? 'cursor-help' : ''
            } ${positive ? 'text-green-500' : 'text-red-500'} ${className ?? ''}`}
        >
            {positive ? '▲' : '▼'} {value}
        </span>
    );

    if (!title) return chip;

    return (
        <TooltipProvider delayDuration={120}>
            <Tooltip>
                <TooltipTrigger asChild>{chip}</TooltipTrigger>
                <TooltipContent
                    side="top"
                    className="border border-border bg-popover font-mono text-[11px] normal-case tracking-normal text-popover-foreground shadow-lg"
                >
                    {title}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
